// SearchBar.js

import React, { useEffect, useState } from "react";
import styles from "./SearchBar.module.css";
import { useDispatch } from "react-redux";
import { setSearchInput } from "../../reduxSlices/headerSlice";

const SearchBar = ({ placeholder }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  useEffect(() => {
    dispatch(setSearchInput(searchTerm));
  }, [searchTerm]);

  return (
    <div className={styles.searchBar}>
      <input
        type="text"
        placeholder={placeholder || "Search here..."}
        value={searchTerm}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default SearchBar;
